import { Injectable } from "@angular/core";
import { ConstantComponent } from "../../constant.component";


@Injectable()
export class CommanService {
    constructor() {}
    getState(): void {}

    gotoService(route, serviceName) {
        ConstantComponent.IframesOfServices.forEach((s: any) => {
            if (s.service == serviceName) {
                window.location.href = `${s.FE_Url}${route}`;
                return;
            }
        });
    }

    clearLocalStorageOfAllServices = () => {
        ConstantComponent.IframesOfServices.forEach((service: any, idx) => {
            this.postCrossDomainData(null, service.id);
            // we should not parse inner value of any key in the cros domin store script
        });
    };

    postCrossDomainData = (msg, frameID) => {
        let win = document.getElementById(frameID) as HTMLIFrameElement;
        if (win.contentWindow != null) {
            win.contentWindow.postMessage(msg, "*");
            // win.contentWindow.postMessage(msg, "http://localhost:4200"); // Invaalid target origin
        }
    };
}
